import React, {useContext, useEffect, useState} from "react";
import {PopUpContext} from "../../contexts/popUpContext";
import {YearContext} from "../../contexts/yearContext";
import db from "../../services/query";

const HeaderYear = () => {

    const {togglePopUp} = useContext(PopUpContext);
    const {entryYear} = useContext(YearContext);
    const [currentEntryYear, setCurrentEntryYear] = useState({});

    useEffect(async () => {
        const ac = new AbortController();
        await db.getAll(`dropdowns/entryyears`).then(({data: {data}}) => {
            const mCurrentEntryYear = data.filter(
                (e) => parseInt(e.id) === parseInt(entryYear)
            )[0];
            setCurrentEntryYear(mCurrentEntryYear);
        });
        return () => ac.abort();
    }, [entryYear]);


    return (
        <div className="header-date"
             onClick={() => togglePopUp({form: "entry-year-pop-up"})}
        >
            <div className="date-box right-dir ">
                <div className="date-wrapper">
                    <div className="day" style={{width: "fit-content"}}>
                        <p>{currentEntryYear?.name}</p>
                    </div>
                </div>
            </div>
        </div>
    );

}

export default HeaderYear;
